import {MenuItem, Select as MUISelect} from "@material-ui/core";
import * as PropTypes from "prop-types";
import React from "react";
import {OptionType} from "../../../../../types/SelectTypes";

const Select = ({
    name,
    entries,
    multiple,
    value,
    onChange,
    onClose,
    className,
    rootClassName,
    native,
    ...props
}) => {

    const handleChange = (event) => {
        if (onChange) {
            onChange(name, event.target.value);
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (

        <MUISelect
            {...props}
            multiple={multiple}
            native={native}
            className={className}
            classes={{root: rootClassName}}
            value={value}
            onChange={handleChange}
            onClose={handleClose}
            inputProps={{
                name: name,
                id: "select",
            }}
        >
            {entries && entries.map(entry => {

                return (
                    <MenuItem
                        key={entry.key}
                        value={entry.value}
                        disabled={entry.disabled}
                        selected={entry.selected}
                    >
                        {entry.label}
                    </MenuItem>
                );
            })}
        </MUISelect>
    );
};

Select.defaultProps = {};

Select.propTypes = {
    name: PropTypes.string.isRequired,
    entries: PropTypes.arrayOf(PropTypes.oneOfType([OptionType, PropTypes.string, PropTypes.any])),
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    className: PropTypes.any,
    rootClassName: PropTypes.any,
    native: PropTypes.bool
};

export default Select;
